module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "width": "700px",
      "title": _vm.originator,
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [(_vm.loadingThreads) ? _c('Loader', {
    attrs: {
      "msg": "Loading conversation"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "thread-container",
    attrs: {
      "id": "threadContainer"
    }
  }, _vm._l((_vm.processedThreads), function(interaction) {
    return _c('div', {
      key: interaction.id
    }, [_c('div', {
      staticClass: "message",
      class: interaction.direction
    }, [(interaction.audio) ? _c('div', {
      staticClass: "audio-container"
    }, [_c('audio', {
      ref: ("audio" + (interaction.id)),
      refInFor: true,
      attrs: {
        "src": interaction.audio,
        "controls": "controls",
        "preload": "none"
      },
      on: {
        "play": function($event) {
          return _vm.mediaStarted(interaction.id)
        },
        "ended": function($event) {
          return _vm.mediaEnded(interaction.id)
        },
        "pause": function($event) {
          return _vm.mediaEnded(interaction.id)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (interaction.video) ? _c('div', {
      staticClass: "video-container"
    }, [_c('video', {
      ref: ("video" + (interaction.id)),
      refInFor: true,
      staticClass: "video-item",
      attrs: {
        "src": interaction.video,
        "controls": "controls",
        "preload": "meta"
      },
      on: {
        "play": function($event) {
          return _vm.mediaStarted(interaction.id)
        },
        "ended": function($event) {
          return _vm.mediaEnded(interaction.id)
        },
        "pause": function($event) {
          return _vm.mediaEnded(interaction.id)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (interaction.image) ? _c('div', {
      staticClass: "image-container"
    }, [_c('image-grid', {
      attrs: {
        "box-width": '370',
        "box-height": '370px',
        "images": [interaction.image]
      },
      on: {
        "imageSelected": _vm.showGallery
      }
    })], 1) : _vm._e(), _vm._v(" "), (interaction.document) ? _c('div', {
      staticClass: "message-container"
    }, [(interaction.document.endsWith('.pdf')) ? _c('div', [_c('a', {
      ref: ("document" + (interaction.id)),
      refInFor: true,
      attrs: {
        "href": interaction.document
      }
    }, [_c('i', {
      staticClass: "fa fa-file-pdf-o"
    }), _vm._v("\n              " + _vm._s(("document_" + (interaction.document.slice(-20)))) + "\n            ")])]) : _c('div', [_c('a', {
      ref: ("document" + (interaction.id)),
      refInFor: true,
      attrs: {
        "href": interaction.document
      }
    }, [(interaction.document.endsWith('.doc') ||
      interaction.document.endsWith('.docx')) ? _c('i', {
      staticClass: "fa fa-file-word-o"
    }) : (interaction.document.endsWith('.xls') ||
      interaction.document.endsWith('.xlsx')) ? _c('i', {
      staticClass: "fa fa-file-excel-o"
    }) : _vm._e(), _vm._v("\n              " + _vm._s(("document_" + (interaction.document.slice(-20)))) + "\n            ")])])]) : _vm._e(), _vm._v(" "), (interaction.text) ? _c('div', {
      staticClass: "message-container"
    }, [_c('a', {
      ref: ("document" + (interaction.id)),
      refInFor: true,
      attrs: {
        "href": interaction.text
      }
    }, [_c('i', {
      staticClass: "fa fa-file-text"
    }), _vm._v(" " + _vm._s(_vm.getDocumentName(interaction.text)) + "\n          ")])]) : _vm._e(), _vm._v(" "), (interaction.message) ? _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatMessage(interaction.message))
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "datetime"
    }, [_vm._v(_vm._s(_vm.displayDatetime(interaction.datetime)))])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])
  }), 0), _vm._v(" "), (!_vm.loadingThreads && _vm.replyExpired) ? _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "text-muted small center"
  }, [_vm._v("\n      24 hour WhatsApp reply period has expired. Due to WhatsApp restrictions replies to this\n      number will not be possible until this number first sends a message to us again.\n    ")])]) : _vm._e(), _vm._v(" "), (!_vm.loadingThreads && _vm.showReplyOption) ? _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.showMediaOption) ? _c('div', {
    staticClass: "upload-media"
  }, [_c('hr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addMedia),
      expression: "addMedia"
    }]
  }), _vm._v(" "), (_vm.mediaList.length > 0) ? _c('div', {
    staticClass: "preview"
  }, [_vm._l((_vm.mediaPreview), function(preview, index) {
    return _c('div', {
      key: index
    }, [(preview.filetype.startsWith('audio')) ? _c('div', {
      staticClass: "audio-preview"
    }, [_c('audio', {
      attrs: {
        "src": preview.url,
        "controls": "controls",
        "preload": "none"
      }
    })]) : _vm._e(), _vm._v(" "), (preview.filetype.startsWith('video')) ? _c('div', {
      staticClass: "video-preview"
    }, [_c('video', {
      staticClass: "video-item",
      attrs: {
        "src": preview.url,
        "controls": "controls",
        "preload": "meta"
      }
    })]) : _vm._e(), _vm._v(" "), (preview.filetype.startsWith('image')) ? _c('div', {
      staticClass: "image-preview"
    }, [_c('image-grid', {
      attrs: {
        "box-width": '370',
        "box-height": '370px',
        "images": [preview.url]
      },
      on: {
        "imageSelected": _vm.showGallery
      }
    })], 1) : _vm._e(), _vm._v(" "), (preview.filetype === 'application/pdf') ? _c('div', [_c('pre', [_vm._v(" "), _c('i', {
      staticClass: "fa fa-file-pdf-o"
    }), _vm._v(" " + _vm._s(preview.filename) + " ")])]) : _vm._e(), _vm._v(" "), (preview.filetype.startsWith('text')) ? _c('div', [_c('pre', [_vm._v(" "), _c('i', {
      staticClass: "fa fa-file-text"
    }), _vm._v(" " + _vm._s(preview.filename) + " ")])]) : _vm._e(), _vm._v(" "), (preview.filetype ===
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document') ? _c('div', [_c('pre', [_vm._v(" "), _c('i', {
      staticClass: "fa fa-file-word-o"
    }), _vm._v(" " + _vm._s(preview.filename) + " ")])]) : _vm._e(), _vm._v(" "), (preview.filetype === 'application/vnd.ms-excel' ||
      preview.filetype === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') ? _c('div', [_c('pre', [_vm._v(" "), _c('i', {
      staticClass: "fa fa-file-excel-o"
    }), _vm._v(" " + _vm._s(preview.filename) + " ")])]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "preview-control"
  }, [_c('el-button', {
    attrs: {
      "type": "danger",
      "plain": ""
    },
    on: {
      "click": _vm.handleClearMedia
    }
  }, [_vm._v("Clear")])], 1)], 2) : _vm._e(), _vm._v(" "), _c('el-upload', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.addMedia && _vm.mediaList.length === 0),
      expression: "addMedia && mediaList.length === 0"
    }],
    staticClass: "post-file-upload",
    attrs: {
      "action": "https://jsonplaceholder.typicode.com/posts/",
      "accept": "image/jpeg, image/png, video/mp4,\n          audio/aac, audio/m4a, audio/amr, audio/mpeg, audio/ogg,\n          application/pdf,\n          application/vnd.ms-excel,\n          application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,\n          application/vnd.openxmlformats-officedocument.wordprocessingml.document,\n          text/csv,\n          text/plain",
      "limit": 1,
      "list-type": 'text',
      "on-change": _vm.handleFileChange,
      "on-remove": _vm.handleFileRemove,
      "file-list": _vm.fileList,
      "auto-upload": false,
      "drag": ""
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._v("\n          Drop file here or\n          "), _c('em', [_vm._v("click to upload")])]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("\n          jpg / png images, mp4 video, mp3 / ogg audio, csv / plain text, xlsx / docx / pdf applications\n        ")])])], 1) : _vm._e(), _vm._v(" "), _c('el-input', {
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.sendReply($event)
      }
    },
    model: {
      value: (_vm.reply),
      callback: function($$v) {
        _vm.reply = $$v
      },
      expression: "reply"
    }
  }, [(_vm.showMediaOption) ? _c('el-button', {
    attrs: {
      "slot": "prepend",
      "icon": "fa fa-paperclip"
    },
    on: {
      "click": _vm.toggleUpload
    },
    slot: "prepend"
  }) : _vm._e(), _vm._v(" "), _c('EmojiKeyboard', {
    staticClass: "emoji-keyboard",
    attrs: {
      "slot": "suffix"
    },
    on: {
      "onEmojiInsert": _vm.handleInsertEmoji
    },
    slot: "suffix"
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "fa fa-arrow-up"
    },
    on: {
      "click": _vm.sendReply
    },
    slot: "append"
  })], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08f8e991","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/interaction/ThreadDialog.vue
// module id = 3127
// module chunks = 3